import { useCallback, useState } from 'react';

function toggleKey(keys: ReadonlySet<string>, key: string): ReadonlySet<string> {
    return keys.has(key) ? new Set([...keys].filter((k) => k !== key)) : new Set([...keys, key]);
}

export interface ExpandedKeys {
    isExpanded: (key: string) => boolean;
    toggle: (key: string) => void;
}

// Which rows of a folded VA list are open; every row starts folded.
export function useExpandedKeys(): ExpandedKeys {
    const [expanded, setExpanded] = useState<ReadonlySet<string>>(() => new Set());
    const toggle = useCallback((key: string) => setExpanded((prev) => toggleKey(prev, key)), []);
    const isExpanded = useCallback((key: string) => expanded.has(key), [expanded]);
    return { isExpanded, toggle };
}
